import { HelmetProvider } from 'react-helmet-async';
import { AppRouter } from './router/AppRouter';
import ChatwootWidget from './components/ChatwootWidget';
import './App.css';
import './styles/cta-button.css';
import './styles/header-mobile-fix.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <ChatwootWidget />
        <AppRouter />
      </div>
    </HelmetProvider>
  );
}

export default App;
